import PropTypes from "prop-types";
import React, { Children } from "react";
import styled, { withTheme } from "styled-components";
import CardSeparator from "../CardSeparator/CardSeparator";

const StyledPaper = styled.div`
  background-color: ${(props) => props?.theme?.white};
  color: ${(props) => props?.theme?.fg};
  border-radius: 12px;

  &.main-paper {
    text-align: left;
    height: 100%;
    width: 100%;
  }

  &.card-header:first-child {
    border-radius: calc(0.6rem - 1px) calc(0.6rem - 1px) 0 0;
  }
  &.card-header {
    padding: 2rem 0.5rem 0.5rem 2rem;
    margin-bottom: 0;
    border-bottom: 0px solid rgba(0, 0, 0, 0.125);
    font-weight: 700;
  }
  .card-admin-header-separator-green {
    width: 40px;
    height: 3px;
    background: ${(props) => props?.theme?.greenGradient};
  }
  @media (min-width: 1024px) {
    .card-body {
      padding: 0.5rem 2rem 2rem 2rem;
    }
  }
  @media only screen and (max-width: 760px),
    (min-device-width: 768px) and (max-device-width: 1024px) {
    border-radius: 0;
    .card-header {
      padding: 0.75rem 1.25rem;
    }
  }
`;

const StyledHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;

  .table-image {
    height: 50px;
    margin: 20px 50px 0 0;
  }

  @media only screen and (max-width: 760px),
    (min-device-width: 768px) and (max-device-width: 1024px) {
    border-radius: 0;
    .table-image {
      margin-top: 2px;
      margin-right: 20px;
    }
  }
`;

const Paper = (props) => {
  const { hasSeparator = true, children, image = "" } = props;
  return (
    <StyledPaper data-testid={props["data-testid"]} className="main-paper">
      <StyledHeader>
        <StyledPaper className="card-header">
          {props.header}
          {hasSeparator && <CardSeparator style={props.cardHeader ?? "-lg"} />}
        </StyledPaper>
        {image && <img src={image} alt="logo" className="table-image" />}
      </StyledHeader>
      <div className="card-body align-middle">
        <div className={`${!props.fullBody ? "h-100 w-100" : ""}`}>
          {props.title ? <h3 className="card-title">{props.title}</h3> : ""}
          {props.text ? <p className="card-text">{props.text}</p> : ""}
          <div>
            {Children.map(children, (subChild) => {
              return <>{subChild}</>;
            })}
          </div>
        </div>
      </div>
    </StyledPaper>
  );
};

Paper.propTypes = {
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  fullBody: PropTypes.bool,
  fullWidth: PropTypes.bool,
  title: PropTypes.string,
  text: PropTypes.string,
  children: PropTypes.node,
};

export default withTheme(Paper);
